const BLOB_URL_REVOKE_DELAY_MS = 60_000;

/**
 * Save a base64 payload to disk under a given name.
 *
 * Uses an anchor with `download` rather than navigating a window, so the browser offers to
 * save the file — and honours the server's filename — instead of opening a viewer.
 */
export const downloadBase64File = (data: string, filename: string, contentType: string): void => {
  const bytes = Uint8Array.from(atob(data), (character) => character.charCodeAt(0));
  const url = URL.createObjectURL(new Blob([bytes], {type: contentType}));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Revoking immediately can cancel the download in some browsers before it starts.
  window.setTimeout(() => URL.revokeObjectURL(url), BLOB_URL_REVOKE_DELAY_MS);
};
